<template>
  <AppLayout>
    <RouterView />
  </AppLayout>
  <ModalsContainer />
  <Toast />
</template>

<script setup lang="ts">
  import Toast from '@/volt/Toast.vue'

  import { RouterView } from 'vue-router'
  import AppLayout from '@/layouts/AppLayout.vue'
  import { ModalsContainer } from 'vue-final-modal'
</script>
<style lang="scss">
  :root {
    --primary-color: #00b9c1;
  }
</style>
